import axios from 'axios';
import type { Trade } from '@/models/trade';

class TradeWebservice {
    public load(withLessons: boolean = true) {
        const url = withLessons ? '/trades?loadLessons=true' : '/trades?loadLessons=false';
        return axios.get<Trade[]>(url);
    }

    public getById(tradeId: string) {
        return axios.get<Trade>('/trades/getById', {
            params: {
                tradeId,
            },
        });
    }

    public ByTopicIdeWithLessons(topicId: number) {
        return axios.get<Trade[]>('/trades/byTopicIdWithLessons', {
            params: {
                topicId,
            },
        });
    }

    public store(trade: Trade) {
        return axios.post('/trades/store', {
            title: trade.title,
            description: trade.description,
            bkp: trade.bkp,
        });
    }

    public update(trade: Trade) {
        return axios.post('/trades/update', {
            id: trade.id,
            title: trade.title,
            description: trade.description,
            bkp: trade.bkp,
        });
    }

    public remove(trade: Trade) {
        return axios.post('/trades/remove', {
            id: trade.id,
        });
    }
}

export const tradeWebservice = new TradeWebservice();
